import cn from 'classnames'
import { FC } from 'react'

import { Tooltip } from 'core-components/library/tooltip'

import { ITopIconProps } from './models/iTopIconProps'

import styles from './TopIcon.module.scss'

export const TopIcon: FC<ITopIconProps> = ({ children, tooltipText, bottomSign }) => {
  return (
    <Tooltip disabled={!tooltipText} tipContent={() => <>{tooltipText}</>}>
      <div className={styles.gobletContainer}>
        <div className={styles.iconWrapper}>{children}</div>
        {bottomSign && (
          <div
            className={cn(styles.bottomSignContainer, {
              [styles.oph]: bottomSign === 'OPH',
              [styles.bps]: bottomSign === 'BPS',
              [styles.retail]: bottomSign === 'Retail',
              [styles.distributor]: bottomSign === 'Distributor',
            })}
          >
            <span>{bottomSign}</span>
          </div>
        )}
      </div>
    </Tooltip>
  )
}
